import * as React from 'react';
import { clsx } from 'clsx';
import styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const RadioToggle = props => {
  const {
    className,
    style
  } = props;
  return /*#__PURE__*/_jsx("span", {
    className: clsx(styles['toggle'], className),
    style: style
  });
};